import React, { useEffect } from "react";
import "./About.scss";
import { Link } from "react-router-dom";
import { useAnalytics } from "../../customHooks/reactGA";

import Appbar from "../../components/Appbar/Appbar";
import Footer from "../../components/Footer/Footer";
import Form from "../../components/Form/Form";
import { Typography, Box, Button } from "@mui/material";

import iconLight from "../../assets/carp_house_plain.png";
import iconDark from "../../assets/carp-house-plain-dark.png";
import TravisHeadshot from "../../assets/Travis_headshot.png";
import SamHeadshot from "../../assets/sam_headshot.png";
import LeviHeadshot from "../../assets/levi_headshot.png";
import RushHeadshot from "../../assets/hs_levi_rush.png";
import Seo from "../../components/Seo/Seo";

const About = (props) => {
  const { trackPageView, trackEvent } = useAnalytics();

  useEffect(() => {
    trackPageView("/about");
  }, [trackPageView]);

  return (
    <div>
      <Seo
        title="About CarpHomes — Indianapolis Cash Home Buyers"
        description="CarpHomes is a local Indiana company that buys houses directly from homeowners, in any condition. No realtor commissions or closing costs, and a member of our team meets you in person."
        pathname="/about"
        />
      <Appbar colorMode={props.colorMode} theme={props.theme} />

      <section
        className="landing"
        style={{
          backgroundColor:
            props.theme.palette.mode === "dark"
              ? props.theme.palette.primary.dark
              : "#e4e4e4",
          backgroundImage:
            props.theme.palette.mode === "dark"
              ? `url(${iconDark})`
              : `url(${iconLight})`,
        }}
      >
        <div className="flex-container main-text-container">
          <div>
            <h1
              className="heading-title l1 heading-title--pop"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.main,
              }}
            >
              Local, Trusted, and Ready to Help.
            </h1>
            <p
              className="heading-title l2"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark,
              }}
            >
              At CarpHomes, we’re more than just real estate investors—we’re
              your neighbors, committed to providing personalized solutions and
              creating positive change in the Indiana communities we call home.
            </p>
          </div>
        </div>
      </section>

      <div className="content-wrapper">
        <Box padding={5} mt={10} mb={10}>
          <Typography
            sx={{
              fontFamily: "karla",
              color:
                props.theme.palette.mode === "dark"
                  ? props.theme.palette.secondary.main
                  : props.theme.palette.primary.main,
              fontSize: "2.25rem",
            }}
          >
            A Family-Owned Business Dedicated to Supporting Our Community
          </Typography>
          <br />
          <Typography
            lineHeight={2.5}
            fontSize={20}
            color={
              props.theme.palette.mode === "dark"
                ? props.theme.palette.common.white
                : props.theme.palette.primary.dark
            }
          >
            As a family-owned, locally-based business, CarpHomes is more than
            just a real estate investor—we’re your neighbors. We’re dedicated to
            helping homeowners in our community by transforming houses into
            better housing opportunities for Hoosiers. We understand the
            emotional and practical challenges of selling a home and work hard
            to make the process as simple and transparent as possible.
          </Typography>
          <br />
          <br />
          <Typography
            sx={{
              fontFamily: "karla",
              color:
                props.theme.palette.mode === "dark"
                  ? props.theme.palette.secondary.main
                  : props.theme.palette.primary.main,
              fontSize: "2rem",
            }}
          >
            What Sets us Apart?
          </Typography>
          <Typography
            lineHeight={2.5}
            fontSize={20}
            color={
              props.theme.palette.mode === "dark"
                ? props.theme.palette.common.white
                : props.theme.palette.primary.dark
            }
          >
            We buy houses in any condition. Whether your property is move-in
            ready or needs significant repairs, we’ll make a fair cash offer.
            Plus, with no realtor commissions or closing costs, selling to us is
            hassle-free and convenient.
          </Typography>
          <br />
          <Typography
            lineHeight={2.5}
            fontSize={20}
            color={
              props.theme.palette.mode === "dark"
                ? props.theme.palette.common.white
                : props.theme.palette.primary.dark
            }
          >
            When CarpHomes makes you an offer, we stand by it! Unlike others who
            might leave you hanging at the closing table, we’re committed to
            seeing the process through. We can even waive inspections, so you
            never have to worry about surprises or last-minute changes. At
            CarpHomes, we’re just as eager as you are to make it to
            closing—quickly and easily.
          </Typography>
        </Box>
      </div>

      <Box
        bgcolor={
          props.theme.palette.mode === "dark"
            ? props.theme.palette.primary.dark
            : "#e4e4e4"
        }
        pt={5}
        pb={10}
      >
        <div className="content-wrapper">
          <div className="team-member-container team-member-container--photo-left">
            <Box className="team-member-profile" padding={2.5}>
              <Box
                bgcolor={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.secondary.main
                    : props.theme.palette.warning.main
                }
                height={"300px"}
                width={"300px"}
                borderRadius={50}
                overflow={"hidden"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"end"}
              >
                <img
                  src={TravisHeadshot}
                  height={"275px"}
                  width={"auto"}
                  style={{
                    marginLeft: "0.75em",
                  }}
                  alt="Travis Carpenter Headshot"
                />
              </Box>
              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={2.5}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Travis Carpenter
              </Typography>
              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={1}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                CEO
              </Typography>
            </Box>

            <Box className="team-member-bio" padding={2.5}>
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                I am an Indianapolis native, proud alumni of Center Grove High
                School, and a graduate of Indiana Wesleyan University in Marion,
                IN, where I earned my bachelor's degree. My journey in real
                estate began in 2018, and since then, I have garnered extensive
                experience in various facets of the industry. From selling homes
                both on and off-market to acquiring properties, managing
                renovation projects, and building rental portfolios, I have
                honed my skills in navigating complex legal transactions and
                providing valuable consulting services.
              </Typography>
              <br />
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                As a dedicated professional, I prioritize exceptional customer
                service and practical problem-solving to ensure client
                satisfaction. My ability to make confident decisions, coupled
                with a steadfast commitment to professionalism, has earned me
                the trust of clients and colleagues alike.
              </Typography>
              <br />
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                Outside of work, I am a fervent people-person who relishes the
                opportunity to forge meaningful connections. Alongside my wife,
                Deanna, I reside in the north suburbs with our two wonderful
                children. Our household is completed by our beloved dogs, Frodo
                and Lexi.
              </Typography>
            </Box>
          </div>

          <div className="team-member-container team-member-container--photo-right">
            <Box className="team-member-bio" padding={2.5}>
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                As a dedicated Customer Service Specialist and a Lead Manager
                with the CarpHomes Team, I am committed to providing exceptional
                support to potential sellers, ensuring their journey is smooth
                and informed. Serving as the primary point of contact, I address
                inquiries, schedule property viewings, and assist with
                documentation. By maintaining clear and proactive communication,
                I aim to foster trust and satisfaction, guiding sellers through
                every step of the process. My commitment is to deliver
                personalized service that meets the unique needs of each client,
                contributing to their success and satisfaction.
              </Typography>
            </Box>
            <Box className="team-member-profile" padding={2.5}>
              <Box
                bgcolor={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.secondary.main
                    : props.theme.palette.warning.main
                }
                height={"300px"}
                width={"300px"}
                borderRadius={50}
                overflow={"hidden"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"end"}
              >
                <img
                  src={SamHeadshot}
                  height={"275px"}
                  width={"auto"}
                  style={{
                    marginLeft: "0.75em",
                  }}
                  alt="Sam Auro Headshot"
                />
              </Box>
              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={2.5}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Sam Auro
              </Typography>
              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={1}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Customer Care Specialist
              </Typography>
            </Box>
          </div>

          <div className="team-member-container team-member-container--photo-left">
            <Box className="team-member-bio" padding={2.5}>
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                After we purchase properties, I plan and manage construction
                crews to bring those properties back to life.
              </Typography>
              <br />
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                Born and raised in the Indianapolis area, I graduated from
                Center Grove High School and have been rooted in the community
                ever since. My career began in construction, working with a
                small company where I gained hands-on experience in everything
                from small repairs to full-scale home rehabs. I transitioned
                into project management for restoration projects involving
                water, fire, and mold damage. With that background, I’ve
                developed a strong understanding of what it takes to bring
                properties back to their full potential.
              </Typography>
              <br />
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                Outside of work, I’m happily married to my wife Alyssa, and we
                have two amazing boys and two great dogs who keep life exciting.
                We live on the Southside of Indy, where I enjoy meeting new
                people and building lasting relationships—whether it’s through
                work or just good conversation and hobbies.
              </Typography>
            </Box>
            <Box className="team-member-profile" padding={2.5}>
              <Box
                bgcolor={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.secondary.main
                    : props.theme.palette.warning.main
                }
                height={"300px"}
                width={"300px"}
                borderRadius={50}
                overflow={"hidden"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"end"}
              >
                <img
                  src={LeviHeadshot}
                  height={"275px"}
                  width={"auto"}
                  style={{
                    marginLeft: "-1em",
                  }}
                  alt="Levi Jacobs Headshot"
                />
              </Box>

              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={2.5}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Levi Jacobs
              </Typography>
              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={1}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Project Manager
              </Typography>
            </Box>
          </div>

          <div className="team-member-container team-member-container--photo-right">
            <Box className="team-member-profile" padding={2.5}>
              <Box
                bgcolor={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.secondary.main
                    : props.theme.palette.warning.main
                }
                height={"300px"}
                width={"300px"}
                borderRadius={50}
                overflow={"hidden"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"end"}
              >
                <img
                  src={RushHeadshot}
                  height={"275px"}
                  width={"auto"}
                  style={{
                    marginLeft: "-1em",
                  }}
                  alt="Levi Rush Headshot"
                />
              </Box>

              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={2.5}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Levi Rush
              </Typography>
              <Typography
                textAlign={"center"}
                fontFamily={"latoBold"}
                mt={1}
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.secondary.main
                      : props.theme.palette.warning.main,
                }}
              >
                Property Solutions Specialist
              </Typography>
            </Box>
            <Box className="team-member-bio" padding={2.5}>
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                I take a hands-on, personal approach to real estate. When I come
                to a property, I sit down with the homeowner, listen to their
                unique selling situation, and work with them to put together a
                clear plan to get the house sold in a way that makes sense for
                everyone involved. After spending more than a decade as a
                welder, I made the move into real estate investing and have been
                fully committed to the industry ever since. What began as a
                personal interest quickly developed into a deep understanding of
                property values, renovation potential, and how to structure
                practical, win-win investment solutions.
              </Typography>
              <br />
              <Typography
                lineHeight={2}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                Outside of work, I enjoy playing golf, hiking, camping, and
                spending time outdoors with my family. Whether it’s a weekend
                trip or just getting outside for the day, I value making the
                most of my time with the people closest to me.
              </Typography>
            </Box>
          </div>
        </div>
      </Box>

      <section
        className="sell-my-home"
        style={{
          backgroundColor:
            props.theme.palette.mode === "dark"
              ? props.theme.palette.secondary.main
              : props.theme.palette.primary.main,
          padding: "10em 5em 10em 5em",
          textAlign: "center",
        }}
      >
        <Box>
          <Typography
            sx={{
              color:
                props.theme.palette.mode === "dark"
                  ? props.theme.palette.primary.main
                  : props.theme.palette.common.white,
              fontSize: "2rem",
              fontFamily: "karla",
            }}
          >
            Ready to sell? Let us make you an offer today.
          </Typography>
        </Box>
        <Box sx={{ marginTop: "2.5em" }}>
          <Button
            variant="contained"
            color="warning"
            sx={{ padding: "15px 25px" }}
            onClick={() =>
              trackEvent("CTA", "Click", "Get Your Cash Offer Now")
            }
          >
            <Link className="link-item" to="/sell-my-home">
              <Typography
                sx={{
                  color:
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.common.white
                      : props.theme.palette.common.white,
                  fontFamily: "latoBold",
                  fontSize: "1.15rem",
                }}
              >
                Get your Cash Offer Now
              </Typography>
            </Link>
          </Button>
        </Box>
      </section>

      <div className="content-wrapper">
        <section className="contact-form">
          <Box mt={15} mb={10}>
            <Typography
              sx={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.main,
                fontSize: "2rem",
                fontFamily: "karla",
                marginBottom: "0.5em",
                textAlign: "center",
              }}
            >
              Get Your Free, No-Obligation Cash Offer Today
            </Typography>
            <Form theme={props.theme} />
          </Box>
          <Box
            mt={15}
            bgcolor={
              props.theme.palette.mode === "dark"
                ? props.theme.palette.primary.light
                : props.theme.palette.secondary.main
            }
            sx={{
              borderRadius: "25px 25px 0 0",
            }}
          >
            <Box className="contact-us-text-container">
              <Typography
                variant="h4"
                fontSize={"2.25rem"}
                fontFamily={"karla"}
                mb={2.5}
                mt={5}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.dark
                }
              >
                Supplemental Services
              </Typography>
              <Typography
                lineHeight={2.5}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                In addition to our core focus of purchasing properties directly,
                our team offers supplemental services tailored to specific
                needs:
              </Typography>
              <Box>
                <ul>
                  <li>
                    <Typography
                      lineHeight={2.5}
                      color={
                        props.theme.palette.mode === "dark"
                          ? props.theme.palette.common.white
                          : props.theme.palette.primary.dark
                      }
                    >
                      <span>
                        <b>Realtor Services - </b>
                      </span>
                      If you're considering selling your home through the
                      traditional market, our team can assist with listing your
                      property and navigating the sales process. While our
                      primary focus is on purchasing homes, this service is
                      available for homeowners who prefer a traditional
                      approach.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      lineHeight={2.5}
                      color={
                        props.theme.palette.mode === "dark"
                          ? props.theme.palette.common.white
                          : props.theme.palette.primary.dark
                      }
                    >
                      <span>
                        <b>Construction Services for Investors - </b>
                      </span>
                      We provide expert construction management services
                      exclusively for real estate investors. Whether you're a
                      seasoned investor or new to the market, we can oversee
                      renovation projects to maximize value and streamline the
                      process. This service is ideal for out-of-state investors
                      looking to expand their portfolio in the Indianapolis area
                      without the hassle of managing projects locally.{" "}
                    </Typography>
                  </li>
                </ul>
              </Box>

              <Box mt={10}>
                <Typography
                  variant="h4"
                  fontSize={"2.25rem"}
                  fontFamily={"karla"}
                  color={
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.warning.main
                      : props.theme.palette.primary.main
                  }
                  mb={2.5}
                  // textAlign={'center'}
                >
                  Sell Your Indiana Home Fast with CarpHomes
                </Typography>
                <Typography
                  lineHeight={2.5}
                  mt={2}
                  color={
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.common.white
                      : props.theme.palette.primary.dark
                  }
                  // textAlign={'center'}
                >
                  We make selling your home easy, fast, and stress-free. As a
                  local Indiana business, we offer cash purchases with no
                  realtor commissions or closing costs. Close in as little as 7
                  days—no repairs, no open houses, no hassle. Enjoy a private,
                  personalized experience with a team that understands your
                  needs every step of the way.
                </Typography>
              </Box>

              <Box display="flex" justifyContent="center" mt={5}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor:
                      props.theme.palette.mode === "dark"
                        ? props.theme.palette.warning.main
                        : props.theme.palette.primary.main,
                  }}
                  onClick={() => trackEvent("CTA", "Click", "Reach Out")}
                >
                  <Link className="link-item" to="/contact">
                    <Typography color={props.theme.palette.common.white}>
                      Reach Out
                    </Typography>
                  </Link>
                </Button>
              </Box>
            </Box>
          </Box>
        </section>
      </div>

      <Box>
        <Footer />
      </Box>
    </div>
  );
};

export default About;
